export enum OperatorTypeEnum {
    Equal = 0,
    LessThan = 1,
    LessThanOrEqual = 2,
    GreaterThan = 3,
    GreaterThanOrEqual = 4,
    NotEqual = 5,
    Contains = 6,
    StartsWith = 7
}